import { Directive, EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Directive()
@Injectable()
export class UtilityService {

  private readonly dropdown_value: string;
  @Output() emit_results_count: EventEmitter<any[]> = new EventEmitter();

  private readonly changeSortByCriteria = new BehaviorSubject<string>('');
  changeSortByCriteria$ = this.changeSortByCriteria.asObservable();

  private readonly emit_search_key = new BehaviorSubject<any>('');
  emit_search_key$ = this.emit_search_key.asObservable();

  private readonly emit_dropdown = new Subject<any>();
  emit_dropdown$ = this.emit_dropdown.asObservable();

  private readonly filterCriteria = new Subject<any>();
  filterCriteria$ = this.filterCriteria.asObservable();

  private readonly broadcastChannelNumber = new Subject<any>();
  broadcastChannelNumber$ = this.broadcastChannelNumber.asObservable();

  private readonly channelSubscriptionToggled = new Subject<any>();
  channelSubscriptionToggled$ = this.channelSubscriptionToggled.asObservable();

  private readonly activeToolReportObject = new Subject<any>();
  activeToolReportObject$ = this.activeToolReportObject.asObservable();

  private readonly passInfo = new Subject<any>();
  passInfo$ = this.passInfo.asObservable();

  private readonly subscribeActiveTab = new Subject<any>();
  subscribeActiveTab$ = this.subscribeActiveTab.asObservable();

  private readonly brandType = new Subject<any>();
  brandType$ = this.brandType.asObservable();

  private readonly shareContentPopup = new Subject<any>();
  shareContentPopup$ = this.shareContentPopup.asObservable();

  constructor() { }

  passNewSortByCriteria(criteria: string) {
    this.changeSortByCriteria.next(criteria);
  }

  changeDropdown(section: string): void {
    this.emit_dropdown.next(section);
  }

  updatedResultsCount(count: any[]) {
    this.emit_results_count.emit(count);
  }

  passSearchKey(searchKey: string) {
    this.emit_search_key.next(searchKey);
  }

  publishFilterCriteria(filter: any) {
    this.filterCriteria.next(filter);
  }

  publishChannelSubscription(toggle: boolean) {
    this.channelSubscriptionToggled.next(toggle);
  }

  publishChannelNumber(channelNumber) {
    this.broadcastChannelNumber.next(channelNumber);
  }

  publishActiveReportObject(report) {
    this.activeToolReportObject.next(report);
  }

  publishInfo(info: any) {
    this.passInfo.next(info);
  }

  publishActiveTab(info: any) {
    this.subscribeActiveTab.next(info);
  }

  closeShareContentPopup(info: any) {
    this.shareContentPopup.next(info);
  }

  sliceAllData(data: any) {
    return data.slice(0, 5000);
  }
  getScreenWidth() {
    return document.documentElement.clientWidth;
  }

  fileValidator(fileName) {
    let fileType = [];
    const allowedFileTypes = [
      'pdf', 'doc', 'docx', 'xls', 'xlsx', 'xml', 'htm', 'html', 'ppt', 'pptx', 'txt', 'png', 'gif', 'jpg',
      'jpeg', 'mov', 'mp3', 'mp4', 'mpg', 'mpa', 'wav', 'wma', 'wmv', 'avi', 'flv', 'm4v', 'zip', 'exe'
    ];
    fileType = fileName.split('.');
    return allowedFileTypes.includes(fileType[(fileType.length - 1)]);
  }

  public getMappingUrl(parm: string): { url: string, param: string } | undefined {
    let mappingUrls = [
      { 'url': 'https://aos.bmwgroup.com/support/techinfo/public/faces/SupportForm.xhtml?langLong=en-US', 'parm': 'ossSupport' },
      { 'url': '/tisUI/#/tis-support', 'parm': 'tisSupport' },
      { 'url': 'https://www.dealer-pc.com/independent/', 'parm': 'productOrdering' },
      { 'url': '/tisUI/#/Model-Map', 'parm': 'modelMap' },
      { 'url': 'https://www.microsoft.com/en-us/windows/ie/default.asp', 'parm': 'microsoft' },
      { 'url': 'https://get.adobe.com/reader/', 'parm': 'adobe' }
    ];

    let parmToUrlMap = new Map();
    for (const element of mappingUrls) {
      parmToUrlMap.set(element.parm, element);
    }
    return parmToUrlMap.get(parm);
  }

  public static scrollPageToStart() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  public static readonly identity = (data) => data

  public static mapObjectEntries<X>(object, mappingFunction: (key: string, value: any) => X): X[] {
    const newObjects: X[] = []
    for (const [key, value] of Object.entries(object ?? {})) {
      newObjects.push(mappingFunction(key, value))
    }
    return newObjects
  }

  public static filterSeriesArray(array, filter) {
    const myArrayFiltered = [];
    for (const element of array) {
      for (const filterElement of filter) {
        if (element.id === filterElement.id && element.seriesName === filterElement.seriesName) {
          myArrayFiltered.push(element);
        }
      }
    }
    return myArrayFiltered;
  }

  public static filterSeriesArrayByName(array, filter) {
    const myArrayFiltered = [];
    for (const element of array) {
      for (const filterElement of filter) {
        if (element.seriesName === filterElement) {
          myArrayFiltered.push(element);
        }
      }
    }
    return myArrayFiltered;
  }
}